import * as React from 'react'

const SvgPinIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.869 8.319l.881-.882L12.5 1.25l-.819.888.738.737L5.237 8.95 4.162 7.881l-.88.869 3.537 3.55-5.569 5.563.881.887L7.7 13.181l3.55 3.538.869-.888-1.069-1.069 6.075-7.18.744.737zm-7.707 5.556L6.125 9.838l7.181-6.088 2.944 2.944-6.088 7.181z"
      fill="#163250"
    />
  </svg>
)

export default SvgPinIcon
